import { render } from "./EditMultiSelectItem.vue?vue&type=template&id=b951f308&scoped=true"
import script from "./EditMultiSelectItem.vue?vue&type=script&lang=js"
export * from "./EditMultiSelectItem.vue?vue&type=script&lang=js"

import "./EditMultiSelectItem.vue?vue&type=style&index=0&id=b951f308&scoped=true&lang=css"
import "./EditMultiSelectItem.vue?vue&type=style&index=1&id=b951f308&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b951f308"]])

export default __exports__